import React from 'react'
import styled from 'styled-components'
import { lightGray } from '../variables.js'
import { blue, gutterSize } from '../variables'

const hideComments = false

const CommentsContainer = styled.div`
  border-top: 1px solid ${lightGray};
  margin: ${gutterSize}px 0 ${gutterSize / 2}px;
`

const CommentContainer = styled.div`
  background-color: white;
  border: 1px solid ${lightGray};
  border-radius: 3px;
  box-shadow: 1px 1px 3px ${lightGray};
  padding: 10px;
  margin: 10px 0;

  :focus {
    outline: none;
  }
`

const Author = styled.h4`
  color: ${blue};
  margin: 0;
`

const Text = styled.p`
  margin: 10px 0;
  text-align: justify;

  :last-of-type {
    margin-bottom: 0;
  }
`

const Title = styled.h3`
  margin: 10px 0;
`

export default class Comment extends React.Component {
  render() {
    if (hideComments || !this.props.comments || !this.props.comments.length) {
      return ''
    }

    const commentsJSX = this.props.comments.map((comment, i) => {
      return (
        <CommentContainer key={i}>
          <Author>{comment.author}</Author>
          <Text>{comment.content}</Text>
        </CommentContainer>
      )
    })

    return (
      <CommentsContainer>
        <Title>Comments</Title>
        {commentsJSX}
      </CommentsContainer>
    )
  }
}
